import React from "react";
import classNames from "classnames";
import { Tooltip } from "antd";
import { EnumTrafficDriverStatus } from "../../utils/api/trafficDriver";
import { CampaignStatus, PublicationStatus, TeaserStatus } from "../../__generated__/graphql";

interface PublicationStatusProps {
  status: PublicationStatus | CampaignStatus | EnumTrafficDriverStatus;
  size?: STATUS_SIZES
  warning?: string
}

export const StatusColors = {
  [PublicationStatus.Active]: {
    color: "bg-green-700",
    // description: "The campaign is live",
    text: "text-white",
  },
  [PublicationStatus.Archived]: {
    color: "bg-blue-100",
    // description: "The campaign is archived",
    text: "text-gray-800",
  },
  [PublicationStatus.Draft]: {
    color: "bg-blue-100",
    // description: "The campaign is in draft mode",
    text: "text-gray-800",
  },
  [PublicationStatus.Finished]: {
    color: "bg-indigo-600",
    // description: "The campaign is finished",
    text: "text-white",
  },
  [PublicationStatus.Paused]: {
    color: "bg-blue-200",
    // description: "The campaign has been paused",
    text: "text-gray-800",
  },
  [PublicationStatus.Ready]: {
    color: "bg-lime-500",
    // description: "The campaign is ready",
    text: "text-white",
  },
  [CampaignStatus.ReviewingByAdvertiser]: {
    color: "bg-teal-500",
    // description: "The campaign has been submitted to the publisher",
    text: "text-white",
  },
  [PublicationStatus.ReviewingByPublisher]: {
    color: "bg-teal-500",
    // description: "The campaign has been submitted to the publisher",
    text: "text-white",
  },

  [TeaserStatus.Inactive]: {
    color: "bg-blue-200",
    // description: "The campaign has been paused",
    text: "text-gray-800",
  }
  // [PublicationStatus.REJECTED]: {
  //   color: "bg-red-500",
  //   description:
  //     "The campaign has been rejected. The campaign owner can re-activate the campaign in draft mode",
  //   text: "text-white",
  // },
  // [EnumTrafficDriverStatus.APPROVED]: {
  //   color: "bg-green-700",
  //   description: "",
  //   text: "text-white",
  // },
  // [EnumTrafficDriverStatus.UNAPPROVED]: {
  //   color: "bg-red-700",
  //   description: "",
  //   text: "text-white",
  // }
};

export enum STATUS_SIZES {
  SMALL = 'small',
  LARGE = 'large'
}

const PublicationStatusBadge: React.FC<PublicationStatusProps> = ({ status, size = STATUS_SIZES.SMALL, warning }) => {
  const className = classNames(
    "inline-flex leading-5 font-semibold rounded-full capitalize relative",
    {
      [STATUS_SIZES.SMALL]: 'text-xs px-2.5 py-0.5',
      [STATUS_SIZES.LARGE]: 'text-sm px-4 py-2'
    }[size],
    // @ts-ignore
    StatusColors[status as any]?.text,
    // @ts-ignore
    StatusColors[status as any]?.color
  );
  return (
    // @ts-ignore
    <span className={className} title={StatusColors[status]?.description}>
      {status?.toLowerCase()?.replaceAll('_', ' ')}

      {warning && (
        <Tooltip title={warning}>
          <div className="w-3 h-3 rounded-full bg-red-500 absolute -top-1 -right-1"></div>
        </Tooltip>
      )}
    </span>
  );
};

export default PublicationStatusBadge;
